import React, { useEffect, useState }  from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  Cell,
  ComposedChart,
  ReferenceLine
} from "recharts";
import * as Icon from 'react-bootstrap-icons';

const printDiv=(printDiv)=>{
  const printElement = document.getElementById(printDiv);

        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                    ${printElement.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
}



const ProSalesProfitGraph=({misDataSum })=>{

    const [chartType, setChartType] = useState("line");
    const [fYear,setfYear]=useState('');

    useEffect(() => {
      if (misDataSum.length > 0) {
      setfYear(misDataSum[0].fYear);
      }
    }, [misDataSum]);

    const maxProValue = Math.max(
        ...misDataSum.map(item => Math.max(item.cumProValue || 0, item.cumPreProValue || 0))
    );

    const maxSalesValue = Math.max(
        ...misDataSum.map(item => Math.max(item.cumSalesValue || 0, item.cumPreSalesValue || 0))
    );

    const maxProfitValue = Math.max(
        ...misDataSum.map(item => Math.max(item.cumProfitLoss || 0, item.cumPreProfitLoss || 0,  item.profitCumMT || 0))
    );

    const minProfitValue = Math.min(
        ...misDataSum.map(item => Math.min(item.cumProfitLoss || 0, item.cumPreProfitLoss || 0, item.profitCumMT || 0))
    );

    return(
        <>
            <div className="card shadow mb-4" id="print_productionGraph">
                <div className="card-header bg-primary text-white d-flex justify-content-between">
                      <h5> Production Comparison Graph{" "}<small>(Amount in Lac)</small> </h5>           
                      <div>
                        <button className="btn btn-sm btn-warning me-2" onClick={() => setChartType("bar")} >
                          <Icon.BarChartLineFill />
                        </button>
                        <button className="btn btn-sm btn-info me-2" onClick={() => setChartType("line")} >
                          <Icon.GraphUpArrow />
                        </button>
                        <button className="btn btn-sm btn-success me-2" onClick={() => printDiv("print_productionGraph")}>
                          <Icon.Printer />
                        </button>
                      </div>
                </div>
            
                    <div className="card-body" >
                        <div style={{ width: "100%", height: 450, overflow: "hidden" }}>
                                    <ResponsiveContainer width="100%" height={420}>
                        
                                      {chartType === "bar" ? (
                        
                                        <BarChart data={misDataSum} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                                          <CartesianGrid strokeDasharray="3 3" />
                        
                                          <XAxis dataKey="branchcode" angle={-30} textAnchor="end"/>
                                          <YAxis domain={[0, Math.ceil(maxProValue * 1.2)]}/>
                                          <Tooltip />
                                          <Legend />
                                               
                                          <Bar dataKey="cumProValue" fill="#198754" name={`Cum. Production (${fYear}-${fYear+1})`} >
                                            <LabelList dataKey="cumProValue" position="top" angle={-90} fill="black"/>
                                          </Bar>
                        
                                          <Bar dataKey="cumPreProValue" fill="#fd7e14" name={`Cum. Production (${fYear-1}-${fYear})`} >
                                            <LabelList dataKey="cumPreProValue" position="top" angle={-90} fill="black"/>
                                          </Bar>
                                        </BarChart>
                        
                                      ) : (
                        
                                        <ComposedChart data={misDataSum} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                                          <CartesianGrid strokeDasharray="3 3" />
                        
                                          <XAxis dataKey="branchcode" angle={-30} textAnchor="end" interval={0}/>
                                          <YAxis domain={[0, Math.ceil(maxProValue * 1.2)]}/>
                                          <Tooltip />
                                          <Legend />
                        
                                          {/* <Bar dataKey="proQty" fill="#198754"  name="Current Production"/> */}
                                          <Line type="monotone" dataKey="cumProValue" stroke="#198754" strokeWidth={3} name={`Cum. Production (${fYear}-${fYear+1})`}
                                            label={{ position: "insideRight" }}
                                          />
                        
                                          <Line type="monotone" dataKey="cumPreProValue" stroke="#fd7e14" strokeWidth={3} name={`Cum. Production (${fYear-1}-${fYear})`}
                                            label={{ position: "insideRight" }}
                                          />
                        
                                        </ComposedChart>
                        
                                      )}
                                    </ResponsiveContainer>
                        </div>
                    </div>
            </div>

            <div className="card shadow mb-4" id="print_salesGraph">
                <div className="card-header bg-primary text-white d-flex justify-content-between">
                      <h5> Sales Comparison Graph{" "}<small>(Amount in Lac)</small></h5>          
                      <div>
                        <button className="btn btn-sm btn-warning me-2" onClick={() => setChartType("bar")} >
                          <Icon.BarChartLineFill />
                        </button>
                        <button className="btn btn-sm btn-info me-2" onClick={() => setChartType("line")} >
                          <Icon.GraphUpArrow />
                        </button>
                        <button className="btn btn-sm btn-success me-2" onClick={() => printDiv("print_salesGraph")}>
                          <Icon.Printer />
                        </button>
                      </div>
                    </div>
            
                    <div className="card-body">
                        <div style={{ width: "100%", height: 450, overflow: "hidden" }}>
                                    <ResponsiveContainer width="100%" height={420}>
                        
                                      {chartType === "bar" ? (
                        
                                        <BarChart data={misDataSum} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                                          <CartesianGrid strokeDasharray="3 3" />
                        
                                          <XAxis dataKey="branchcode" angle={-30} textAnchor="end"/>
                                          <YAxis domain={[0, Math.ceil(maxSalesValue * 1.2)]}/>
                                          <Tooltip />
                                          <Legend />
                                               
                                          <Bar dataKey="cumSalesValue" fill="#198754" 
                                            name={`Cum. Sales(${fYear}-${fYear+1})`} >
                                            <LabelList dataKey="cumSalesValue" position="top" angle={-90} fill="black"/>
                                          </Bar>
                        
                                          <Bar dataKey="cumPreProValue" fill="#fd7e14" 
                                            name={`Cum. Sales(${fYear-1}-${fYear})`} >
                                            <LabelList dataKey="cumPreSalesValue" position="top" angle={-90} fill="black"/>
                                          </Bar>
                                        </BarChart>
                        
                                      ) : (
                        
                                        <ComposedChart data={misDataSum} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                                          <CartesianGrid strokeDasharray="3 3" />
                        
                                          <XAxis dataKey="branchcode" angle={-30} textAnchor="end" interval={0}/>
                                          <YAxis domain={[0, Math.ceil(maxSalesValue * 1.2)]}/>
                                          <Tooltip />
                                          <Legend />
                        
                                          {/* <Bar dataKey="proQty" fill="#198754"  name="Current Production"/> */}
                                          <Line type="monotone" dataKey="cumSalesValue" stroke="#198754" strokeWidth={3} 
                                            name={`Cum. Sales(${fYear}-${fYear+1})`}
                                            label={{ position: "insideRight" }}
                                          />
                        
                                          <Line type="monotone" dataKey="cumPreSalesValue" stroke="#fd7e14" strokeWidth={3} 
                                            name={`Cum. Sales(${fYear-1}-${fYear})`}
                                            label={{ position: "insideRight" }}
                                          />
                        
                                        </ComposedChart>
                        
                                      )}
                                    </ResponsiveContainer>
                        </div>
                    </div>
            </div>

            <div className="card shadow mb-4" id="print_profitGraph">
                <div className="card-header bg-primary text-white d-flex justify-content-between">
                      <h5>Profit-Loss Comparison{" "}<small>(Amount in Lac)</small></h5>          
                      <div>
                        <button className="btn btn-sm btn-warning me-2" onClick={() => setChartType("bar")} >
                          <Icon.BarChartLineFill />
                        </button>
                        <button className="btn btn-sm btn-info me-2" onClick={() => setChartType("line")} >
                          <Icon.GraphUpArrow />
                        </button>
                        <button className="btn btn-sm btn-success me-2" onClick={() => printDiv("print_profitGraph")}>
                          <Icon.Printer />
                        </button>
                      </div>
                </div>
            
                    <div className="card-body">
                        <div style={{ width: "100%", height: 450, overflow: "hidden" }}>
                                    <ResponsiveContainer width="100%" height={420}>
                        
                                      {chartType === "bar" ? (
                        
                                        <BarChart data={misDataSum} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                                          <CartesianGrid strokeDasharray="3 3" />
                        
                                          <XAxis dataKey="branchcode" angle={-30} textAnchor="end" interval={0}/>
                                          <YAxis domain={[Math.floor(minProfitValue), Math.ceil(maxProfitValue * 1.2)]}/>
                                          <ReferenceLine y={0} stroke="red" strokeWidth={5} strokeDasharray="5 5"/>
                                          <Tooltip />
                                          <Legend />

                                          <Bar dataKey="profitCumMT" fill="#3a0be2" 
                                            name={`Profit Target(${fYear}-${fYear+1})`} >
                                            <LabelList dataKey="profitCumMT" position="top" angle={-90} fill="black"/>
                                          </Bar>
                                               
                                          <Bar dataKey="cumProfitLoss" fill="#198754" 
                                            name={`Cum. Profit(${fYear}-${fYear+1})`} >
                                            <LabelList dataKey="cumProfitLoss" position="top" angle={-90} fill="black"/>
                                          </Bar>
                        
                                          <Bar dataKey="cumPreProfitLoss" fill="#fd7e14" 
                                            name={`Cum. Profit(${fYear-1}-${fYear})`} >
                                            <LabelList dataKey="cumPreProfitLoss" position="top" angle={-90} fill="black"/>
                                          </Bar>
                                        </BarChart>
                        
                                      ) : (
                        
                                        <ComposedChart data={misDataSum} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                                          <CartesianGrid strokeDasharray="3 3" />
                        
                                          <XAxis dataKey="branchcode" angle={-30} textAnchor="end" interval={0}/>
                                          <YAxis domain={[Math.floor(minProfitValue), Math.ceil(maxProfitValue * 1.2)]}/>
                                          <ReferenceLine y={0} stroke="red" strokeWidth={1} strokeDasharray="4 4" />
                                          <Tooltip contentStyle={{ fontSize: "12px" }}/>
                                          <Legend />

                                          <Line type="monotone" dataKey="profitCumMT" stroke="#4710ee" strokeWidth={3} 
                                            name={`Profit Target(${fYear}-${fYear+1})`}
                                            label={{ position: "insideRight", angle:0,fontSize: 14,}}
                                          />
                        
                                          <Line type="monotone" dataKey="cumProfitLoss" stroke="#198754" strokeWidth={3} 
                                            name={`Cum. Profit(${fYear}-${fYear+1})`}
                                            label={{ position: "insideRight", angle:0,fontSize: 14,}}
                                          />
                        
                                          <Line type="monotone" dataKey="cumPreProfitLoss" stroke="#fd7e14" strokeWidth={3} 
                                            name={`Cum. Profit(${fYear-1}-${fYear})`}
                                            label={{ position: "insideRight", angle:-45,fontSize: 14,}}
                                          />
                        
                                        </ComposedChart>
                        
                                      )}
                                    </ResponsiveContainer>
                        </div>
                    </div>
            </div>
        </>
    )
}

export default ProSalesProfitGraph;